import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { dataAll } from '../../../../service/data.service';
import { Loading } from '../../../../components/Loading';
import ComparativoReceitaRecebidoTable from '../../../../components/Financial/ComparativoReceitaRecebido/Table';
import ComparativoReceitaRecebidoFilter from '../../../../components/Financial/ComparativoReceitaRecebido/Filter';

const ComparativoReceitaRecebidoFranquia = () => {

  const [isLoading, setIsLoading] = useState(false)
  const [filters, setFilters] = useState({ year: '', month: '' })
  const [relatorio, setRelatorio] = useState({})
  const [pesquisaRealizada, setPesquisaRealizada] = useState(false)

  const fetchAllItems = async (filtro) => {
    try {
      setIsLoading(true)
      const response = await dataAll('/income-received-comparison', { params: filtro })
      setRelatorio(response || {
        "manualBillingsReceived": 0,
        "taxesFromOfx": 0,
        "taxesFromM3tas": 0,
        "zurichComissionsFromOfx": 0,
        "zurichComissionsFromM3tas": 0
      })


    } catch (error) {
      toast.error('Erro ao buscar relatório comparativo receita x recebido. Favor tentar novamente dentro de alguns instantes. Sinalize o suporte caso persista. Erro técnico:', error)

    } finally {
      setIsLoading(false)
      setPesquisaRealizada(true)
    }
  }

  const clickFilter = () => {
    fetchAllItems(filters)
  }

  const clearFilter = () => {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth() + 1
    setFilters({ month: currentMonth, year: currentYear })
  }

  useEffect(() => {
    clearFilter()
  }, [])

  return (
    <>
      <ComparativoReceitaRecebidoFilter
        filters={filters}
        setFilters={setFilters}
        clickFilter={clickFilter}
        clearFilter={clearFilter}
      />

      {
        isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '128px' }}>
            <Loading />
          </div>
        ) : (
          pesquisaRealizada && (
            <ComparativoReceitaRecebidoTable relatorio={relatorio} />
          )
        )
      }
    </>
  )
}

export default ComparativoReceitaRecebidoFranquia